import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "mt-4 border-t border-gray-200 pt-3.5" }
const _hoisted_2 = { class: "text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_3 = {
  key: 0,
  class: "mt-2 flex flex-wrap gap-1.5"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-2 text-xs text-gray-400"
}
const _hoisted_5 = {
  key: 2,
  class: "mt-2 text-xs text-amber-700"
}
const _hoisted_6 = {
  key: 3,
  class: "mt-2 text-xs text-gray-400"
}
const _hoisted_7 = { class: "mt-2 max-w-[76ch] text-xs leading-relaxed text-gray-500" }
const _hoisted_8 = { class: "mt-4 flex flex-wrap items-center gap-3" }

import LlTextarea from '@/components/LlTextarea.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { CONFLICT_SCOPE_SENTENCE } from '../constants/conflictFieldConstants';
import type { ConflictParty } from '../models/conflictTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConflictQueryPanel',
  props: {
    modelValue: {},
    includeTimeEntries: { type: Boolean },
    parties: {},
    partyCount: {},
    running: { type: Boolean },
    skippedParties: {},
    ignoredRoleWords: {}
  },
  emits: ["update:modelValue", "update:includeTimeEntries", "removeParty", "run"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

function onKeydown(event: KeyboardEvent): void {
  if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
    event.preventDefault();
    emit('run');
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "border border-gray-200 px-4 py-4",
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(LlTextarea, {
        id: "conflict-query",
        "model-value": __props.modelValue,
        label: "Names to check",
        rows: 4,
        placeholder: "Sample Trust Company\nJohn Doe",
        "hide-details": "",
        "data-cy": "conflict-query-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event))),
        onKeydown: onKeydown
      }, null, 8, ["model-value"]),
      _cache[11] || (_cache[11] = _createElementVNode("p", { class: "mt-2 text-xs leading-relaxed text-gray-700" }, [
        _createTextVNode(" Separate names with a "),
        _createElementVNode("span", { class: "font-medium" }, "semicolon"),
        _createTextVNode(" or a "),
        _createElementVNode("span", { class: "font-medium" }, "new line"),
        _createTextVNode(". A comma stays inside a name — "),
        _createElementVNode("span", { class: "italic text-gray-500" }, "Big Corporation, Inc."),
        _createTextVNode(" is one name. ")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, " Checking " + _toDisplayString(__props.partyCount) + " " + _toDisplayString(__props.partyCount === 1 ? 'name' : 'names'), 1),
        (__props.parties.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.parties, (party, index) => {
                return (_openBlock(), _createBlock(_component_v_chip, {
                  key: `${party}-${index}`,
                  size: "small",
                  label: "",
                  variant: "outlined",
                  closable: "",
                  "data-cy": `conflict-party-chip-${index}`,
                  "close-label": `Remove ${party}`,
                  "onClick:close": ($event: any) => (emit('removeParty', index))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(party), 1)
                  ]),
                  _: 2
                }, 1032, ["data-cy", "close-label", "onClick:close"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_4, " No names yet. Type one to see it appear here. ")),
        (__props.skippedParties.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.skippedParties.length) + " " + _toDisplayString(__props.skippedParties.length === 1 ? 'name was' : 'names were') + " skipped — only a role or entity word to search on. ", 1))
          : _createCommentVNode("", true),
        (__props.ignoredRoleWords.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Ignored as role words: " + _toDisplayString(__props.ignoredRoleWords.join(', ')), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(LlCheckbox, {
        class: "mt-3",
        "model-value": __props.includeTimeEntries,
        label: "Include time entry descriptions — slower on large firms",
        "data-cy": "conflict-include-time-entries",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:includeTimeEntries', $event)))
      }, null, 8, ["model-value"]),
      _createElementVNode("p", _hoisted_7, [
        _createTextVNode(" Searches " + _toDisplayString(_unref(CONFLICT_SCOPE_SENTENCE)), 1),
        (__props.includeTimeEntries)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[3] || (_cache[3] = _createTextVNode(", ", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "font-medium text-gray-700" }, "and time entry descriptions", -1)),
              _cache[5] || (_cache[5] = _createTextVNode(". ", -1))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[6] || (_cache[6] = _createTextVNode(" . ", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-medium text-gray-700" }, "Time entries are not included.", -1))
            ], 64)),
        _cache[8] || (_cache[8] = _createTextVNode(" Invoice narratives are not searched. ", -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(LlSecondaryButton, {
          color: "primary",
          disabled: !__props.partyCount,
          loading: __props.running,
          "data-cy": "conflict-run",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('run')))
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode(" Run conflict check ", -1)
          ]))]),
          _: 1
        }, 8, ["disabled", "loading"]),
        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "or press ⌘↵", -1))
      ])
    ]),
    _: 1
  }))
}
}

})